import CatalogoFamilia from "../catalogoFamilia/catalogoFamilia";
import "./montajeMobiliario.scss";

export default function MontajeMobiliario() {
    return (
        <CatalogoFamilia
            title="Montaje de mobiliario"
            className="montaje-mobiliario"
            codFamilia={12}
        />
    );
}
